export default __webpack_public_path__ + "static/media/36I-102741_-15817_0.d4dc75e5.jpg";